<!-- 分页 -->
<template>
    <div class="page" v-if="total > 9">
        <el-pagination
        background
        layout="slot"
        :total="total"
        :page-size="pageSize">
        </el-pagination>
        <el-pagination
        background
        layout="pager, slot"
        :total="total"
        :page-size="pageSize"
        :current-page="page"
        @current-change="clickPage"
        >
        <div class="slot last-pager" @click="jumpPage('0')">尾页</div>
        </el-pagination>
    </div>
</template>

<script>
export default {
    props:{
        total: {
            type: Number,
            default: 0
        },
        page: {
            type: Number,
            default: 1
        },
        pageSize: {
            type: Number, 
            default: 4
        }
    },
    data () {
        return {
        }
    },
    watch:{
        page (newVal){
            return newVal
        }
    },
    methods:{
        jumpPage(val){
            switch(val){
                case "0"://跳转到末页
                this.$emit('currentPage', Math.ceil(this.total/this.pageSize));
                break;
            }
        },
        clickPage(i){
            this.$emit('currentPage', i)
        }
    }
}
</script>
<style scoped lang="less">
@media screen and (min-width: 1029px) and (max-width: 1440px){
    .slot{
        width: 30px;
        height: 30px;
        line-height: 30px;
        font-size: 12px;
    }
}
@media screen and (min-width: 1445px){
    .slot{
        width: 40px;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
    }
}
.slot{
    vertical-align: top;
    display: inline-block;
    background: #fff;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-align: center;
    cursor: pointer;
    border-radius: 50%;
    color: #19191A;
}
.slot:hover{
    background: #19191A;
    color: #fff;
}
.last-pager{
    margin-left: 10px;
}
/* 分页器 */
.page{
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Pagination.vue